import React from 'react'
import styled from 'styled-components'

import { Translate } from '@hozana/intl/Translate'
import { IMAGE_SIZES } from '@hozana/styling/image'
import { EVENT_ORIGIN, TRACKING_SOURCE } from '@hozana/tracking/constants'

import { Button } from 'elements/button/Button'
import { Container } from 'elements/layout/Container'
import { VariableHeightImage } from 'elements/media/VariableHeightImage'
import { P } from 'elements/text/P'

import { Popin } from 'general/managers/popins/Popin'
import { TPopinComponent } from 'general/managers/popins/types'
import { PAGE } from 'routes/pages'

import { type TCommunity } from 'modules/community/types'

import { POPIN_CTA } from '../constants'
import { getPopinId, getPopinIds } from '../functions'

const StyledImage = styled(VariableHeightImage)`
  border-radius: 10px;
`

const StyledUl = styled.ul`
  padding: 20px 0;
`

export type TGuideCommunityPopinOptions = {
  community: TCommunity
  idSuffix: number
  variant?: string
}

export const GuideCommunityPopin: TPopinComponent<TGuideCommunityPopinOptions> = ({
  options: {
    community: { id, isSeoIndexed, lifetime, name, nbMembers, picture, slug },
    idSuffix,
    variant,
  },
}) => (
  <Popin
    h="auto"
    noScroll
    borderRadius="10px"
    fullScreen={false}
    m="1em"
    hidden
    onClose={() => undefined} // Display the close button. full-ssr-functions will attach an event listener
    returnArrow={false}
    ids={getPopinIds(idSuffix, variant)}
  >
    <Container p="50px 25px 25px">
      <StyledImage src={picture} size={IMAGE_SIZES.community.big} alt={name} />
      <P color="darkBlue" bold fontSize="1.5em" p="1em 0 0">
        <Translate values={{ lifetime }}>trans:guide:guide.join.community</Translate>
      </P>
      <P color="yellow" bold fontSize="1.5em">
        {name}
      </P>
      <StyledUl>
        {[
          { key: 'guide:guide.join.get-today' },
          { key: 'guide:guide.join.free' },
          { key: 'guide:guide.join.members-count', values: { nbMembers } },
        ].map(({ key, values }) => (
          <li key={key}>
            <P fontSize="1.1em" p="5px">
              •&nbsp;&nbsp;<Translate values={values}>{key}</Translate>
            </P>
          </li>
        ))}
      </StyledUl>
      <Button
        colors="yellow"
        id={getPopinId(POPIN_CTA, idSuffix, variant)}
        valueLink={{
          to: {
            pathname: PAGE.COMMUNITY_VIEW_LANDING,
            query: {
              communityId: id,
              communitySlug: slug,
              course: 'direct',
              origin: idSuffix === 2 ? EVENT_ORIGIN.GUIDE_POPIN_2 : EVENT_ORIGIN.GUIDE_POPIN,
              source: idSuffix === 2 ? TRACKING_SOURCE.GUIDE_POPIN_2 : TRACKING_SOURCE.GUIDE_POPIN,
            },
          },
          asButton: !isSeoIndexed,
          target: '_blank',
          noReferrer: true,
        }}
        size="big"
        w={1}
      >
        trans:guide:words.i-subscribe
      </Button>
    </Container>
  </Popin>
)
